import { confirmEvent, createEvent, updateEvevntStatus } from "../../services/selectTimeService";
import { ACTION_PARAM, APPOINTMENT_ACTIONS, APPOINTMENT_DATE_RANGE, HOST_TYPE_COLLECTIVE, HOST_TYPE_ROUND_ROBIN, SCREEN } from "../../utils/constants";
import { addDays, CompareObjectDate, convertUnixTimeToObjectDate } from "../../utils/dateTimeHelpers";
import { getLocalTimezoneName } from "../../utils/getLocalTimezoneName";
import { appointmentChannelId, appointmentDateRange, assignedStaffId, businessName, carouselCountLeft, currentDateInUse, customField, customFields, form, leadInfo, locationId, patientSelected, procedures, proceduresOfAppointmentChannel, providerId, providers, selectedAddons, selectedAppointmentUnixTime, selectedLocation, selectedProcedures, setAppointmentDuration, setAppointmentSummary, setCarouselCountLeft, setCurrentDateInUse, setCustomField, setCustomFields, setEventId, setEventPayload, setEventRoom, setFirstQuestion, setLeadInfo, setLeadTextId, setProgressQuestion, setSelectedAppointmentUnixTime, shouldCollectPatientInfoFirstForWidget, staffId, appointmentQuestionsCompleted } from "../../utils/variables";
import { loadAppoimentsSummary } from "../../views/components/appointmentSummary";
import { loadAppointmentConfirmed } from "../../views/components/appointmentConfirmed";
import { toastError } from "../../views/components/error";
import { loadConsultDetail } from "../../views/pages/consultSummary";
import { addressCollectionListeners } from "../events/addressCollectionListeners";
import { appointmentConfirmedListeners } from "../events/appointmentConfirmedListeners";
import { appointmentSummaryListeners } from "../events/appointmentSummaryListeners";
import { loadCardCollection } from "../events/cardCollectionListeners";
import { getClassScreen, navigate, params } from "../events/movePages";
import { registerNewPatientContinueBtnListeners, registerNewPatientInputFieldListeners } from "../events/registerNewPatientListeners";
import { leadMonthCurrent } from "../events/selectTimeListeners";
import { loadAppointmentRescheduleReason } from "../../views/components/appointmentRescheduleReason";
import { appointmentRescheduleReasonListeners } from "../events/appointmentRescheduleReasonListeners";
import { loadCustomFields } from "./consultActions";
import { loadAllQuestionsFlow, shouldShowAllQuestions } from "./allQuestionsFlow";

export function getAppoitmentsDatetime() {
    let dateArray = [];
    let monthArray = [];

    if (!currentDateInUse) {
        setCurrentDateInUse(moment().unix());
    }
    let currentDate = appointmentChannelId ? moment().startOf('month').unix() : moment(currentDateInUse * 1000).startOf('day').unix();
    const dateRange = form?.appointment_channel?.max_advance_into_the_future_in_days || APPOINTMENT_DATE_RANGE;
    const maxBookDate = addDays(moment().endOf('day').unix(), dateRange);
    let stopDate = moment(maxBookDate * 1000).endOf('month').unix();
    while (currentDate < stopDate) {
        let currentDateObj = convertUnixTimeToObjectDate(currentDate);
        dateArray.push({
            date: currentDateObj.date,
            day: currentDateObj.day,
            month: currentDateObj.month,
            year: currentDateObj.year,
            unixTime: currentDate,
            monthId: null
        });
        if (monthArray.findIndex(element => element.month === currentDateObj.month && element.year === currentDateObj.year) == -1) {
            monthArray.push({
                id: null,
                month: currentDateObj.month,
                year: currentDateObj.year,
                dateCount: 1
            });
            monthArray[monthArray.length - 1].id = monthArray.length - 1;
        } else {
            monthArray[monthArray.length - 1].dateCount += 1;
        }
        currentDate = addDays(moment(currentDate * 1000).startOf('day').unix(), 1);
    }
    return { dateArr: dateArray, monthArr: monthArray };
}

export function clickDateCarouselItem(clickedDate) {
    let i = 0;
    let len = appointmentDateRange.dateArr.length;
    while (i < len) {
        let appointmentDateObj = convertUnixTimeToObjectDate(appointmentDateRange.dateArr[i].unixTime);
        let availableAppointmentObj = convertUnixTimeToObjectDate(clickedDate);
        if (CompareObjectDate(appointmentDateObj, availableAppointmentObj)) {
            let buttons = document.querySelectorAll(`${(appointmentChannelId && !shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container' : '.selectTime__container'} .selectTime__wrappers .selectTime__carousel ${appointmentChannelId && !shouldCollectPatientInfoFirstForWidget ? '.selectOnlyTime-carousel__list' : '.selectTime-carousel__list '} .selectTime-carousel__item button`);
            const buttonsArray = Array.from(buttons)?.filter(btn => {
                let div = btn?.closest('.selectTime-carousel__item');
                return div && div.style.visibility !== 'hidden';
            });
            if (buttonsArray.length) {
                buttonsArray[i].click();
            }
            let dateLeftBtn = document.querySelector(`${(appointmentChannelId && !shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container' : '.selectTime__container'} .date__left`);
            let dateRightBtn = document.querySelector(`${(appointmentChannelId && !shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container' : '.selectTime__container'} .date__right`);
            let targetPage = Math.floor(i / 5);
            if (targetPage > carouselCountLeft) {
                let step = targetPage - carouselCountLeft;
                for (let i = 0; i < step; i++) {
                    dateRightBtn.click();
                }
            } else if (targetPage < carouselCountLeft) {
                let step = carouselCountLeft - targetPage;
                for (let i = 0; i < step; i++) {
                    dateLeftBtn.click();
                }
            }
            break;
        }
        i++;
    }
}

function getStaffIdForHostType() {
    const hostType = form?.appointment_channel?.host;

    if (hostType === HOST_TYPE_ROUND_ROBIN || hostType === HOST_TYPE_COLLECTIVE) {
        if (assignedStaffId) {
            return assignedStaffId;
        }
        return null;
    }

    // "Any Provider" mode: use the staff assigned to the selected slot
    if (providerId === -1) {
        return assignedStaffId || null;
    }

    const selectedProviderId = providerId || staffId;

    const staff = providers.find((provider) =>
        provider.id === selectedProviderId
    );

    return staff?.id;
}

export async function appointmentItemsClickEventHandler(timeValue, dataInfoLead = null) {
    setSelectedAppointmentUnixTime(timeValue);
    const qualificationFields = appointmentChannelId
        ? form?.appointment_channel?.qualification_form?.custom_fields || []
        : [];
    if (appointmentChannelId && qualificationFields.length > 0 && !appointmentQuestionsCompleted && shouldShowAllQuestions()) {
        if (!customFields?.length) {
            setCustomFields(qualificationFields);
        }
        loadAllQuestionsFlow();
        return;
    }
    loadSpinnerIcon();
    if (leadInfo) {
        const action = params(ACTION_PARAM);
        if (action === APPOINTMENT_ACTIONS.RESCHEDULE) {
            let startEndTime = timeValue.split('/');
            let newStartTime = parseInt(startEndTime[0]);
            let newEndTime = parseInt(startEndTime[1]);

            loadSpinnerIcon(false);
            loadAppointmentRescheduleReason(newStartTime, newEndTime);
            appointmentRescheduleReasonListeners();
            document.querySelector(getClassScreen(SCREEN.APPOINTMENT_RESCHEDULE_REASON)).style.transition = 'none';
            navigate(SCREEN.APPOINTMENT_RESCHEDULE_REASON);
            return;
        }


        if (providers.length > 0) {
            let provider = providers.find((i) => i.id === providerId);
            const procedureList = (appointmentChannelId && form?.appointment_channel?.procedures?.length >= 1) ? form?.appointment_channel?.procedures : procedures;
            let selectedProceduresObj = selectedProcedures.map((i) =>
                procedureList.find((j) => j.id === i)
            ).filter(Boolean);
            if (!selectedProcedures?.length && appointmentChannelId) {
                selectedProceduresObj = proceduresOfAppointmentChannel ?? [];
            }
            const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking)
            // "Any Provider": resolve from the slot's assigned staff
            if (!provider && providerId === -1 && assignedStaffId) {
                provider = staffsOfAppointmentChannel?.find(s => s.id === +assignedStaffId);
            }
            if (!provider && appointmentChannelId && staffsOfAppointmentChannel?.length) {
                provider = staffsOfAppointmentChannel?.[0]
            }
            if (selectedProceduresObj) {
                loadConsultDetail(provider, selectedProceduresObj);
            }
            let startEndTime = timeValue.split('/');
            let startTime = parseInt(startEndTime[0]);
            let endTime = parseInt(startEndTime[1]);

            let payload = {
                location_id: locationId,
                type: "standard",
                procedure_ids: selectedProceduresObj.map((i) => i.id) || [],
                procedure_addon_ids: selectedAddons.map((i) => i.id) || [],
                participants: [
                    {
                        name: `${leadInfo.first_name} ${leadInfo.last_name}`,
                        participable_type: "App\\Models\\Lead",
                        participable_id: leadInfo.id
                    },
                    ...(getStaffIdForHostType() ? [{
                        name: `${provider.first_name} ${provider.last_name}`,
                        participable_type: "App\\Models\\Staff",
                        participable_id: provider.id
                    }] : []),
                ],
                start_time: startTime,
                end_time: endTime,
                status: "pending",
                description: `${leadInfo.first_name} ${leadInfo.last_name} appointment with ${provider.first_name} ${provider.last_name} - ${moment(startTime * 1000).format('dddd DD MMMM - hh:mm A')}`,
                title: `${businessName ? `${businessName} - Consult` : `Appointment with ${provider.first_name} ${provider.last_name}`}`,
            };
            payload.participants.forEach((item, index) => {
                if (leadInfo.email && leadInfo.email.length > 0 && item.participable_type === 'App\\Models\\Lead') {
                    payload.participants[index]['email'] = leadInfo.email;
                }
            });

            const timezone = getLocalTimezoneName();

            let createEventPayload = {
                start_time: startTime,
                procedure_ids: (appointmentChannelId && form.appointment_channel.procedures?.length === 1 ? form.appointment_channel.procedures || [] : selectedProceduresObj).map((i) => i.id) || [],
                procedure_addon_ids: selectedAddons.map((i) => i.id) || [],
                lead_id: leadInfo.id,
                title: payload.title,
                staff_id: getStaffIdForHostType(),
                ...(selectedLocation && { location_id: selectedLocation }),
                ...(dataInfoLead && {
                    lead_info: {
                        ...dataInfoLead,
                        ...(timezone && { timezone })
                    }
                }),
                ...(patientSelected && patientSelected !== 'all' && {
                    patient_type: patientSelected
                }),
            };
            try {
                let createEventRes = await createEvent(form.appointment_channel.id, createEventPayload);

                if (createEventRes?.data?.participants?.length) {
                    const foundLead = createEventRes.data.participants.find(participant => participant.participable_type === 'App\\Models\\Lead')?.participable;
                    if (foundLead) {
                        setLeadTextId(foundLead.text_id);
                        setLeadInfo(foundLead);
                    }
                }

                // Hold-then-book: for widgets with an intake form configured
                // the API returns the intake URL at CREATE time and leaves the
                // event pending — the slot is held, staff aren't notified,
                // nothing syncs to the EHR yet. Submitting the intake is what
                // actually books it, so redirect before any confirm call.
                const holdIntakeUrl = createEventRes?.data?.intake_redirect_url;
                if (holdIntakeUrl) {
                    window.parent.location.href = holdIntakeUrl;
                    return;
                }

                let confirmEventRes = await confirmEvent(createEventRes.data.id, form.appointment_channel.id);
                setAppointmentSummary(confirmEventRes.data);
                setAppointmentDuration({
                    duration: confirmEventRes.data.duration || 0,
                    requires_consult: confirmEventRes.data.requires_consult
                });

                setEventPayload(payload);
                setEventId(createEventRes.data.id);

                if (shouldSkipQuestions() || appointmentChannelId) {
                    // Address is collected on the "Verify your information" page
                    // (see verifyInforListenters.js), so no dedicated address screen here.
                    const needsDepositOrCard = form?.appointment_channel?.collect_card_on_booking && form?.stripe_publishable_key;
                    if (needsDepositOrCard) {
                        // Consolidated final step: condensed recap + card form on one
                        // screen. A standalone summary screen before the card ask reads
                        // like a confirmation, so patients leave believing they booked.
                        loadCardCollection();
                    } else {
                        const confirmRes = await updateEvevntStatus(createEventRes.data.id);

                        // Slot → intake handoff: the API returns this only for
                        // widgets configured with an intake form. Send the
                        // visitor straight into their paperwork (Solv-style) —
                        // the URL carries a signed token with the booking, so
                        // the form shows what they booked without PHI in the
                        // query string.
                        const intakeUrl = confirmRes?.data?.intake_redirect_url;
                        if (intakeUrl) {
                            window.parent.location.href = intakeUrl;
                            return;
                        }

                        setEventRoom(confirmRes.data.event_room || null);
                        setEventPayload(confirmRes.data);
                        loadAppointmentConfirmed();
                        appointmentConfirmedListeners();
                        navigate(SCREEN.APPOINTMENT_CONFIRMED);
                    }
                } else {
                    loadQuestionnaire();
                }

            } catch (error) {
                toastError(error.response?.data?.message);
            } finally {
                loadSpinnerIcon(false);
            }
        }
    } else {
        try {
            registerNewPatientInputFieldListeners();
            registerNewPatientContinueBtnListeners();
            navigate(SCREEN.REGISTER_NEW_PATIENT);
        } catch (error) {
            toastError(error.response?.data?.message);
        } finally {
            loadSpinnerIcon(false);
        }
    }
}

export async function clearContainer(containerClass) {
    document.querySelector(containerClass).innerHTML = '';
}

export async function removeAllAppointmentListItem() {
    const containerClass = (appointmentChannelId && !shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container .selectTime__list' : '.selectTime__container .selectTime__list';
    await clearContainer(containerClass);
}

export async function resetCarouselItem() {
    setCarouselCountLeft(0);
    const containerClass = (appointmentChannelId && !shouldCollectPatientInfoFirstForWidget) ? '.selectOnlyDate__container .selectTime-carousel__list' : '.selectTime__container .selectTime-carousel__list';
    await clearContainer(containerClass);
}

export async function resetPageSelectTime() {
    resetCarouselItem();
    removeAllAppointmentListItem();
}

export async function loadSpinnerIcon(isLoading = true) {
    if (!isLoading) {
        document.querySelectorAll('.selectTime__list .selectTime__item').forEach(element => {
            element.style.pointerEvents = 'auto';
        });
        document.querySelector(`[data-time-value="${selectedAppointmentUnixTime}"] .selectTime__right-arrow`)?.classList.remove('hidden');
        document.querySelector(`[data-time-value="${selectedAppointmentUnixTime}"] .selectTime__spinner`)?.classList.add('hidden');
    } else {
        document.querySelectorAll('.selectTime__list .selectTime__item').forEach(element => {
            element.style.pointerEvents = 'none';
        });
        document.querySelector(`[data-time-value="${selectedAppointmentUnixTime}"] .selectTime__right-arrow`)?.classList.add('hidden');
        document.querySelector(`[data-time-value="${selectedAppointmentUnixTime}"] .selectTime__spinner`)?.classList.remove('hidden');
    }
}

export function clickOnlyDateCarouselItem(clickedDate) {
    const dateContainer = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item-Month');
    const dateList = document.querySelector('.selectOnlyDate__container .selectOnlyTime-carousel__list');
    const selectTimeItemWidth = document.querySelector('.selectOnlyDate__container .selectTime__carousel')?.offsetWidth || 0;
    const maxWidth = (dateContainer.length - 1) * selectTimeItemWidth;

    let targetIndex = -1;
    let i = 0;
    let len = appointmentDateRange.dateArr.length;

    while (i < len) {
        let appointmentDateObj = convertUnixTimeToObjectDate(appointmentDateRange.dateArr[i].unixTime);
        let availableAppointmentObj = convertUnixTimeToObjectDate(clickedDate);
        if (CompareObjectDate(appointmentDateObj, availableAppointmentObj)) {
            targetIndex = i;
            break;
        }
        i++;
    }

    if (targetIndex !== -1) {
        const targetMonth = Math.floor(targetIndex / 30);
        let currentWidth = targetMonth * selectTimeItemWidth;

        currentWidth = Math.min(currentWidth, maxWidth);

        dateList.style.transform = `translateX(-${currentWidth}px)`;

        leadMonthCurrent(Math.floor(currentWidth / selectTimeItemWidth));

        const dateLeftBtn = document.querySelector('.selectOnlyDate__container .date__left');
        const dateRightBtn = document.querySelector('.selectOnlyDate__container .date__right');

        if (currentWidth <= 0) {
            dateLeftBtn.classList.add('date__left-right--disable');
        } else {
            dateLeftBtn.classList.remove('date__left-right--disable');
        }

        if (currentWidth >= maxWidth) {
            dateRightBtn.classList.add('date__left-right--disable');
        } else {
            dateRightBtn.classList.remove('date__left-right--disable');
        }

        const buttons = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item button');
        const buttonsArray = Array.from(buttons)?.filter(btn => {
            let div = btn?.closest('.selectTime-carousel__item');
            return div && div.style.visibility !== 'hidden';
        });

        if (buttonsArray.length && buttonsArray[targetIndex]) {
            buttonsArray[targetIndex].click();
        }
    }
}

function shouldSkipQuestions() {
    const questionnaire = appointmentChannelId
        ? form?.appointment_channel?.qualification_form?.custom_fields
        : form?.form?.custom_fields;

    if (questionnaire?.length) {
        return false;
    }

    return providerId !== 172;
}

function loadQuestionnaire() {
    const questionnaire = appointmentChannelId
        ? form?.appointment_channel?.qualification_form?.custom_fields
        : form?.form?.custom_fields;

    if (!questionnaire?.length) {
        return;
    }

    const firstQuestion = questionnaire[0];
    const totalQuestions = questionnaire.length;

    setProgressQuestion({
        currentQuestion: 1,
        total: totalQuestions,
        progress: (1 / totalQuestions) * 100
    });

    setCustomField(firstQuestion);
    setFirstQuestion(true);
    loadCustomFields(customField);
}

export function loadAppointmentSummary() {
    loadAppoimentsSummary();
    navigate(SCREEN.APPOINTMENT_SUMMARY);
    appointmentSummaryListeners();
}